import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import ServiceMap from "@/components/site/ServiceMap";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import ScrollHint from "@/components/site/ScrollHint";

export default function Landing() {
  return (
    <main className="min-h-screen bg-[#F9F9FB] text-zinc-900" data-testid="landing-root">
      <Nav />
      <Hero />
      <Marquee />
      <Services />
      <Process />
      <ServiceMap />
      <Faq />
      <Contact />
      <Footer />
      <ScrollHint target="#services" />
    </main>
  );
}
